import i18next from 'i18next';

i18next.addResources('es_CL', 'EmptyBlocks', {
  title: 'Actualmente sin productos bloqueados'
});

i18next.addResources('es_CR', 'EmptyBlocks', {
  title: 'Actualmente sin productos bloqueados'
});
